import React from 'react'
import { Card } from 'react-bootstrap'
import { useIntl } from 'react-intl'

const AdminAppCard = ({ stat, title, comparer }: { stat: any; title: string; comparer: any }) => {
    const { formatMessage } = useIntl()
    return (
        <Card className='w-100 p-4 py-6'>
            <div className='d-flex align-items-center gap-2'>
                <div className=' ps-1 d-flex align-items-center gap-2'>
                    <p className='font-size-24 font-weight-600 mb-0'>{stat}</p>
                    <p className={`mb-0 d-flex gap-2 align-items-center font-size-14 ${comparer.slice(0, 1) === "-" ? 'text-danger' : 'text-success'}`}>
                        {comparer.length !== 0 && <i className={`fa-solid fa-angle-${comparer.slice(0, 1) === "-" ? 'down text-danger' : 'up text-success'}`}></i>}
                        {comparer}</p>
                </div>
            </div>
            <div>
                <p className='font-size-14 text-muted mb-0'>{formatMessage({ id: title })}</p>
            </div>
        </Card>
    )
}

export default AdminAppCard
